import { Mail, Phone } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LEAD_STATUSES } from "@/content/navigation";

export const STATUS_STYLES = {
  New: "bg-plum text-white",
  Contacted: "bg-amber-100 text-amber-900",
  Qualified: "bg-sky-100 text-sky-900",
  Converted: "bg-emerald-100 text-emerald-900",
  Closed: "bg-zinc-200 text-zinc-800",
};

export const fmtDate = (d) => {
  const date = new Date(d);
  return Number.isNaN(date.getTime()) ? "—" : date.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
};

export const StatusSelect = ({ value, onChange, testid }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className={`h-9 w-[132px] rounded-full border-0 text-xs font-semibold ${STATUS_STYLES[value] || ""}`} data-testid={testid}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {LEAD_STATUSES.map((s) => <SelectItem key={s} value={s} data-testid={`${testid}-option-${s.toLowerCase()}`}>{s}</SelectItem>)}
    </SelectContent>
  </Select>
);

const Row = ({ label, children }) => (
  <div className="grid grid-cols-[120px_1fr] gap-3 border-t border-ink/10 py-3 text-sm">
    <span className="text-ink/60">{label}</span>
    <span className="break-words text-ink">{children || "—"}</span>
  </div>
);

export const EnquiryDialog = ({ enquiry, onClose, onStatus }) => (
  <Dialog open={Boolean(enquiry)} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-h-[90vh] overflow-y-auto bg-ivory sm:max-w-xl" data-testid="enquiry-dialog">
      {enquiry && (
        <>
          <DialogHeader>
            <DialogTitle className="font-display text-2xl font-light text-ink">{enquiry.name}</DialogTitle>
            <DialogDescription>{enquiry.category} · {fmtDate(enquiry.created_at)}</DialogDescription>
          </DialogHeader>
          <div className="mt-2">
            <Row label="Email"><a href={`mailto:${enquiry.email}`} className="inline-flex items-center gap-1.5 text-plum underline-offset-2 hover:underline" data-testid="enquiry-dialog-email"><Mail className="h-3.5 w-3.5" />{enquiry.email}</a></Row>
            <Row label="Phone">{enquiry.phone && <a href={`tel:${enquiry.phone}`} className="inline-flex items-center gap-1.5 text-plum"><Phone className="h-3.5 w-3.5" />{enquiry.phone}</a>}</Row>
            <Row label="Organisation">{enquiry.organisation}</Row>
            <Row label="Service">{enquiry.service}</Row>
            <Row label="Source">{enquiry.source_page}</Row>
            <Row label="Status"><StatusSelect value={enquiry.status} onChange={(s) => onStatus(enquiry.id, s)} testid="enquiry-dialog-status" /></Row>
            <div className="border-t border-ink/10 pt-4">
              <p className="text-sm text-ink/60">Message</p>
              <p className="mt-2 whitespace-pre-wrap text-[15px] leading-relaxed text-ink" data-testid="enquiry-dialog-message">{enquiry.message}</p>
            </div>
          </div>
        </>
      )}
    </DialogContent>
  </Dialog>
);
